import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";

const input = "h-11 px-3 rounded-md border border-zinc-200 bg-white focus:outline-none focus:ring-2 focus:ring-[#0055FF]";

export function AdminCoupons() {
  const [list, setList] = useState([]);
  const [f, setF] = useState({ code: "", percent: 10, max_uses: 0 });
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/admin/coupons").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/admin/coupons", { code: f.code, percent: Number(f.percent), max_uses: Number(f.max_uses) });
      toast.success("Cupom criado");
      setF({ code: "", percent: 10, max_uses: 0 });
      load();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };
  const toggle = async (c) => {
    await api.patch(`/admin/coupons/${c.id}`);
    load();
  };
  const remove = async (c) => {
    if (!window.confirm(`Excluir o cupom ${c.code}?`)) return;
    await api.delete(`/admin/coupons/${c.id}`);
    load();
  };

  return (
    <div className="mt-6 space-y-6" data-testid="admin-coupons">
      <form onSubmit={create} className="bg-white border border-zinc-200 rounded-lg p-5 grid sm:grid-cols-4 gap-3 items-end">
        <div className="sm:col-span-2">
          <label className="text-sm font-medium">Código</label>
          <input required value={f.code} onChange={(e) => setF({ ...f, code: e.target.value.toUpperCase().replace(/[^A-Z0-9_-]/g, "") })} placeholder="ASSESSORIA10" data-testid="coupon-code-input" className={`${input} mt-1 w-full`} />
        </div>
        <div>
          <label className="text-sm font-medium">Desconto (%)</label>
          <input type="number" min="1" max="90" required value={f.percent} onChange={(e) => setF({ ...f, percent: e.target.value })} data-testid="coupon-percent-input" className={`${input} mt-1 w-full`} />
        </div>
        <div>
          <label className="text-sm font-medium">Limite de usos (0 = ilimitado)</label>
          <input type="number" min="0" value={f.max_uses} onChange={(e) => setF({ ...f, max_uses: e.target.value })} data-testid="coupon-maxuses-input" className={`${input} mt-1 w-full`} />
        </div>
        <button disabled={saving} data-testid="coupon-create-btn" className="sm:col-span-4 h-11 rounded-md bg-[#0055FF] hover:bg-[#0040CC] disabled:opacity-60 text-white font-semibold flex items-center justify-center gap-2">
          <Plus className="w-4 h-4" /> {saving ? "Criando…" : "Criar cupom"}
        </button>
      </form>

      <div className="bg-white border border-zinc-200 rounded-lg divide-y divide-zinc-200" data-testid="coupon-list">
        {list.length === 0 && <p className="p-5 text-zinc-500">Nenhum cupom criado.</p>}
        {list.map((c) => (
          <div key={c.id} className="p-4 flex items-center gap-4" data-testid={`coupon-row-${c.code}`}>
            <div className="flex-1">
              <div className="font-display font-bold text-lg tracking-tight">{c.code}</div>
              <div className="text-sm text-zinc-500">{c.percent}% off · {c.uses} uso(s){c.max_uses ? ` de ${c.max_uses}` : ""}</div>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <Switch checked={c.active} onCheckedChange={() => toggle(c)} data-testid={`coupon-toggle-${c.code}`} />
              {c.active ? "Ativo" : "Pausado"}
            </div>
            <button onClick={() => remove(c)} data-testid={`coupon-delete-${c.code}`} className="w-9 h-9 rounded-md border border-zinc-200 grid place-items-center hover:border-red-400">
              <Trash2 className="w-4 h-4 text-red-500" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
